import api from './../../api/api'

export default {

  companies: async (page, take, sortBy, sortOrder, search,filters) => {
    return api.get(`api/companies?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  create: async company => {
    return api.post('api/companies',company)
  },

  get: async id => {
    return api.get('api/companies/' + id)
  },

  update: async (id,company) => {
    return api.put('api/companies/' + id, company)
  },

  delete: async id => {
    return api.delete('api/companies/' + id)
  }
}
